<template>
    <div id="griglia-selezione-foto">
        <vue-headful :title="pageTitle" />
        <div class="body-wrapper">
            <header
                role="navigation"
                class="navbar fixed-top navbar-light shadow p-0"
            >
                <div class="row w-100 mx-0 py-3">
                    <div class="selezione-titolo col-12 text-uppercase text-center">
                        <a
                            class="pulsante-indietro position-absolute ml-3"
                            style="left: 0;"
                            @click.prevent="onPhotoSelectionBackClicked()"
                            href="#"
                        >
                            <font-awesome-icon :icon="['fas', 'chevron-left']" />
                            &nbsp;
                            <span class="d-none d-sm-inline">{{ $t("Indietro") }}</span>
                        </a>
                        <span class="">{{ selectionTitle }}</span>
                    </div>
                </div>

                <div class="selezione-info col-12 w-100 text-center py-2">
                    <span class="">{{ selectionDetails }}</span>
                </div>
            </header>

            <main>
                <div class="visualizzazione-foto">

                    <div class="container-fluid px-0">
                        <div class="row m-0">
                            <div
                                class="thumb_wrapper col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                                v-for="(photo, index) in loadedPhotos"
                                :key="index"
                            >
                                <div
                                    class="thumb"
                                    :style="_photoStyle(photo).image"
                                    @click.prevent="onPhotoSelectionChange(photo)"
                                >
                                    <span
                                        v-if="photo.selectionPosition>0"
                                        class="selected"
                                    >{{photo.selectionPosition}}</span>
                                </div>
                            </div>
                        </div>

                        <div
                            class="container-bottom"
                            ref="bottom"
                            v-observe-visibility="{ callback: loadMore, throttle: 300 }"
                        />
                    </div>
                </div>
            </main>

            <footer class="fixed-bottom text-center">
                <div class="footer">
                    <b-button
                        class="btn btn-rikorda1"
                        @click.prevent="createProduct()"
                    >
                        <span class="mr-2">{{ $t('Continua') }}</span>
                        <font-awesome-icon :icon="['fas', 'chevron-right']" />
                    </b-button>
                </div>
            </footer>

        </div>
    </div>
</template>

<script>
import Footer from "../../components/backend/Footer.vue";
import { ObserveVisibility } from "vue-observe-visibility";
export default {
    name: "GalleryCustomizableProduct",

    directives: {
        "observe-visibility": ObserveVisibility
    },

    components: {},

    data() {
        return {
            eventId: null,
            busy: true,
            author: null,
            title: null,
            pageTitle: null,
            gallery: null,
            productData: {
                numPhotos: 0
            },
            photos: [],
            loadedPhotos: [],
            selectedPhotos: [],
            scrollStep: 10
        };
    },

    created() {
        let productDataBase64 = this.$route.params.productDataBase64;
        this.productData = JSON.parse(atob(productDataBase64));

        this.eventId = this.$store.getters.eventData.eventId;

        this.$store
            .dispatch("GET_GALLERY_DATA", {
                albumId: this.$route.params.albumId
            })
            .then((result) => {
                console.debug("GET_GALLERY_DATA", result);
                this.gallery = result.gallery;
                this.photos = result.photos;
                this.scrollStep = result.scrollStep;
                this.author = this.gallery.author;
                this.title = this.gallery.title;
                this.setPageTitle();
                this.busy = false;
                this.$nextTick(() => {
                    this.loadMore();
                });
            })
            .catch((error) => {
                console.error("GET_GALLERY_DATA", error);
                this.$router.push({
                    name: "gallery-dashboard",
                    params: {
                        galleryUrl: this.$route.params.galleryUrl
                    }
                });
            })
            .finally(() => {});
    },

    computed: {
        numPhotosMissing() {
            return this.productData.numPhotos - this.selectedPhotos.length;
        },

        allSelected() {
            return this.selectedPhotos.length == this.productData.numPhotos;
        },

        selectionTitle() {
            if (this.photos.length < this.productData.numPhotos) {
                return "Seleziona foto";
            }

            if (this.selectedPhotos.length > 0) {
                let num =
                    this.productData.numPhotos - this.selectedPhotos.length;
                return "Seleziona ancora " + num + " foto";
            }

            return "Seleziona " + this.productData.numPhotos + " foto";
        },

        selectionDetails() {
            return (
                "Foto selezionate " +
                this.selectedPhotos.length +
                " di " +
                this.productData.numPhotos
            );
        }
    },

    methods: {
        setPageTitle() {
            if (this.gallery) {
                this.pageTitle = [
                    this.gallery.title,
                    this.$t("di"),
                    this.gallery.author,
                    "- Rikorda"
                ].join(" ");
            }
        },

        getUrl(photoId) {
            return this.$imagesService.getUrl(photoId, "event-web", true);
        },

        loadMore() {
            if (this.loadedPhotos.length < this.photos.length) {
                this.busy = true;

                var start = this.loadedPhotos.length;
                for (let i = 0; i < this.scrollStep; i++) {
                    let idx = start + i;
                    if (this.photos.length > idx) {
                        this.loadedPhotos.push(this.photos[idx]);
                    }
                }

                this.busy = false;
            }
        },

        onPhotoSelectionBackClicked() {
            console.log("MARK: onPhotoSelectionBackClicked");
            this.$router.push({
                name: "gallery-dashboard",
                params: {
                    galleryUrl: this.$route.params.galleryUrl
                }
            });
        },

        onPhotoSelectionChange(photo) {
            var index = this.selectedPhotos.indexOf(photo.id);
            if (index > -1) {
                this.selectedPhotos.splice(index, 1);
            } else if (
                this.selectedPhotos.length < this.productData.numPhotos
            ) {
                this.selectedPhotos.push(photo.id);
            }

            this.loadedPhotos.forEach((photo) => {
                var pos = this.selectedPhotos.indexOf(photo.id);
                photo.selectionPosition = pos + 1;
            });
        },

        createProduct() {
            console.log("MARK", this.selectedPhotos);
            // FIXME: alert se ha selezionato meno foto di quelle necessarie per completare il prodotto
            // FIXME: chiamata al server per creare il progetto con le foto selezionate e redirect a mediaclip
            this.$api
                .customizableProductCreateProject(
                    this.productData.productId,
                    this.productData.themeUrl,
                    this.productData.title,
                    this.selectedPhotos
                )
                .then((response) => {
                    console.log("CUSTOMIZABLE_PRODUCT_CREATE_PROJECT");
                    let projectId = response.projectId;
                    this.$router.push({
                        name: "gallery-project",
                        params: {
                            galleryUrl: this.$route.params.galleryUrl,
                            projectId: projectId
                        }
                    });
                })
                .catch((error) => {
                    console.error("CUSTOMIZABLE_PRODUCT_CREATE_PROJECT", error);
                });
        },

        _photoStyle(photo) {
            return {
                image: {
                    background:
                        "url(" +
                        this.getUrl(photo.id) +
                        ") 50% 50% / cover no-repeat"
                }
            };
        }
    }
};
</script>

<style scoped>
.selezione-titolo {
    color: var(--blu-rikorda);
    font-family: brandon-medium;
}

.selezione-info {
    background-color: var(--tiffany);
    color: var(--blu-rikorda);
    font-family: brandon-medium;
}

.thumb {
    height: 100%;
}

.thumb_wrapper {
    padding: 1px;
}

@media (max-width: 575px) {
    .thumb_wrapper {
        width: 50vw;
        height: 50vw;
    }
}
@media (min-width: 576px) and (max-width: 767px) {
    .thumb_wrapper {
        width: 50vw;
        height: 50vw;
    }
}
@media (min-width: 768px) and (max-width: 991px) {
    .thumb_wrapper {
        width: 33.3vw;
        height: 33.3vw;
    }
}
@media (min-width: 992px) and (max-width: 1199px) {
    .thumb_wrapper {
        width: 25vw;
        height: 25vw;
    }
}
@media (min-width: 1200px) {
    .thumb_wrapper {
        width: 16.6vw;
        height: 16.6vw;
    }
}

.selected {
    background: var(--tiffany);
    color: var(--bianco);
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 1.7rem;
    text-align: center;
    position: absolute;
    right: 0.2rem;
    bottom: 0.2rem;
    opacity: 0.9;
    vertical-align: middle;
    line-height: 2.5rem;
    font-family: brandon-bold;
}

#griglia-selezione-foto .footer {
    background-color: var(--bianco);
    padding: 0.5rem 0;
}
</style>
